import { BookOpenCheckIcon, FileTextIcon, FolderOpenIcon, LightbulbIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Nuclear Energy Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering nuclear fundamentals, atoms and isotopes, radioactivity, fission and energy production, reactors and power plants, nuclear fuel cycle, radiation protection and safety, nuclear waste and environmental management, climate and environment, nuclear energy in society, and critical thinking scenarios. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Nuclear Energy Assessment Bank',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout a nuclear energy course. Includes:',
    items: [
      'Short-answer questions',
      'True/false with explanation',
      'Concept explanations',
      'Misconception correction',
      'Written comparisons',
      'Classroom scenarios',
      'Evidence-based reasoning',
      'Open-ended questions',
      'Reflection prompts',
      'Comprehensive assessment opportunities',
      'Suggested answers and key concepts',
      'Teacher evaluation guidance',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Nuclear Energy Case Studies & Real-World Scenarios',
    description:
      'A collection of 100 developed nuclear energy cases involving nuclear science and radioactivity, fission and energy production, reactors and power plants, nuclear fuel cycle, radiation protection and safety, nuclear events and lessons learned, waste and long-term management, climate and environment, and energy decision-making.',
    benefit:
      'Students analyze evidence, answer guiding questions, evaluate situations, justify ideas, and think critically.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: '50 Nuclear Energy Classroom Projects & Challenges',
    description:
      '50 structured classroom projects that encourage students to investigate nuclear energy topics, analyze problems, develop understanding, make recommendations, and communicate their learning through practical classroom work. Each includes objectives, background information, student challenges, instructions, guiding questions, and assessment criteria.',
    benefit: 'Your students finish the year with real nuclear energy learning projects.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '05',
    title: "Nuclear Energy Teacher's Concept & Terminology Guide",
    description:
      'Comprehensive reference handbook covering essential Nuclear Energy terminology and concepts. Designed to help teachers and students quickly review vocabulary related to atomic and nuclear science, radioactivity and radiation, fission and energy production, reactors and power plants, nuclear fuel cycle, nuclear safety, radiation protection, radioactive waste, decommissioning, climate and environment, electricity and energy systems, and nuclear energy in society.',
    benefit: 'Project it in class and your students instantly understand complex nuclear energy concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
